import useNotifications from '@anm/hooks/useNotifications';

import { MoveProjectState } from '../../../../store/modules/videoFolder/types';

const errorMessage = "Couldn't move the video";

const useMoveProjectNotifications = (entity: MoveProjectState) => {
  const { notifications } = useNotifications({
    ...entity,
    errorMessage
  });

  return { moveProjNotifications: notifications };
};

export default useMoveProjectNotifications;
